module.exports = __webpack_public_path__ + "img/andrew-thank-you.a515a624.png";